import axiosInstance from '../api';
import { notification } from 'antd';

export const listCampaigns = async ({
  skip = 0,
  limit = 10,
  search = "",
  is_active = null,
  start_date = null,
  end_date = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (search) params.append("search", search);
    if (is_active !== null && is_active !== undefined) params.append("is_active", is_active);
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);

    const response = await axiosInstance.get(`/campaign/list?${params.toString()}`);
    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Campaigns",
      description: response?.data?.message || "Failed to fetch campaign list.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching Campaigns",
      description: error.response?.data?.message || "Failed to fetch campaign list.",
      duration: 3,
    });
    throw new Error("Error fetching campaign list");
  }
};

export const downloadEmailCampaign = async ({
  search = "",
  is_active = null,
  start_date = null,
  end_date = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (search) params.append("search", search);
    if (is_active !== null && is_active !== undefined) params.append("is_active", is_active);
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);

    const response = await axiosInstance.get(`/campaign/export_campaign_list?${params.toString()}`, {
      responseType: "blob", // Ensures the response is treated as a file
    });

    if (response.status === 200) {
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // extract filename from Content-Disposition header
      const disposition = response.headers["content-disposition"];
      let filename = "Email_campaign.xlsx"; // fallback
      if (disposition && disposition.includes("filename=")) {
        filename = disposition
          .split("filename=")[1]
          .replace(/['"]/g, ""); // remove quotes if present
      }
      a.download = filename; // Set the filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      return response;
    } else {
      throw new Error("Download failed Email campaign");
    }
  } catch (error) {
    console.error("Error downloading Email campaign:", error);
    notification.error({
      message: "Error Downloading Email campaign",
      description: error.response?.data?.message || "Failed to download Email campaign.",
      duration: 3,
    });
    throw error;
  }
};

export const getCampaignRecipients = async ({ campaign_id, skip = 0, limit = 10 } = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("campaign_id", campaign_id);
    params.append("skip", skip);
    params.append("limit", limit);

    const response = await axiosInstance.get(`/campaign/recipients?${params.toString()}`);
    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Recipients",
      description: response?.data?.message || "Failed to fetch campaign recipients.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching Recipients",
      description: error.response?.data?.message || "Failed to fetch campaign recipients.",
      duration: 3,
    });
    throw new Error("Error fetching campaign recipients");
  }
};

// recipients: [{ user_id, user_itinerary_id }, ...] - each recipient gets
// their own itinerary emailed to them, not one itinerary shared by everyone.
export const createCampaign = async ({ title, template_id = null, recipients = [] }) => {
  try {
    const response = await axiosInstance.post(`/campaign/create`, {
      title,
      template_id,
      recipients,
    });
    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Creating Campaign",
      description: response?.data?.message || "Failed to create campaign.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Creating Campaign",
      description: error.response?.data?.message || "Failed to create campaign.",
      duration: 3,
    });
    throw new Error("Error creating campaign");
  }
};

export const toggleCampaignActive = async ({ campaign_id, is_active }) => {
  try {
    const response = await axiosInstance.post(`/campaign/toggle-active`, {
      campaign_id,
      is_active,
    });
    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Updating Campaign",
      description: response?.data?.message || "Failed to update campaign status.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Updating Campaign",
      description: error.response?.data?.message || "Failed to update campaign status.",
      duration: 3,
    });
    throw new Error("Error updating campaign status");
  }
};
